export default "__VITE_ASSET__Cgo8bhoA__";